import { render } from "./returnprocessedvsgeneratedtrend.vue?vue&type=template&id=03621cb4"
import script from "./returnprocessedvsgeneratedtrend.vue?vue&type=script&lang=js"
export * from "./returnprocessedvsgeneratedtrend.vue?vue&type=script&lang=js"

import "./returnprocessedvsgeneratedtrend.vue?vue&type=style&index=0&id=03621cb4&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__